import React, { useEffect } from "react"

import Body from "./Body"

const Component = ({ children }) => {
  // make sure to scroll the body to the top when navigating
  useEffect(() => {
    if (window && window.location.hash) {
      return
    }
    const element = document.querySelector("#body")
    if (element && typeof element.scrollTo === "function") {
      element.scrollTo(0, 0)
    } else if (element) {
      element.scrollTop = 0
    }
  }, [children])

  return <Body>{children}</Body>
}

export default Component
